module.exports = __webpack_public_path__ + "static/media/KR.5adfd676.svg";